// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/unplanned */
export async function unplannedControllerUpdate(
	body: API.UnplannedUpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/unplanned', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/unplanned/${param0} */
export async function unplannedControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.UnplannedControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.UnplannedViewResponse>(`/api/unplanned/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/unplanned/${param0} */
export async function unplannedControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.UnplannedControllerCreateParams,
	body: API.UnplannedCreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/unplanned/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 DELETE /api/unplanned/${param0}/${param1} */
export async function unplannedControllerDelete(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.UnplannedControllerDeleteParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, id: param1, ...queryParams } = params;
	return request<boolean>(`/api/unplanned/${param0}/${param1}`, {
		method: 'DELETE',
		params: { ...queryParams },
		...(options || {}),
	});
}
